import { render, staticRenderFns } from "./ChatBoto.vue?vue&type=template&id=5cdeebd7&scoped=true&"
import script from "./ChatBoto.vue?vue&type=script&lang=js&"
export * from "./ChatBoto.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoto.vue?vue&type=style&index=0&id=5cdeebd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdeebd7",
  null
  
)

export default component.exports